import { tickerItems } from '../content/siteContent'
export default function Ticker(){ return <div className="ticker"><div className="ticker-track">{[...tickerItems,...tickerItems].map((item,index)=><span className="ti" key={`${item}-${index}`}><span className="td"/>{item}</span>)}</div></div> }
